import { Box, Button, Divider, Flex, Icon, Text } from "@chakra-ui/react";
import React from "react";
import { FaVoicemail } from "react-icons/fa";

const TldrWriterCard = ({
  title,
  description,
  icon,
  iconColor,
  bgColor,
  onClick,
}) => {
  return (
    <Box
      bg="brand.glass_dark_08"
      padding={4}
      marginBottom={4}
      height="100%"
      onClick={onClick}
      cursor="pointer"
      borderRadius="8px"
      _hover={{boxShadow:"0 0 40px 0 rgba(0, 0, 0, 0.5)"}}
    >
      <Flex align="center">
        <Flex
          h="40px"
          w="40px"
          background={iconColor ? `${iconColor}1a` : "rgba(0, 209, 255, 0.1)"}
          borderRadius="8px"
          justify="center"
          align="center"
          mr={3}
        >
          <Icon as={icon} color={iconColor ? iconColor : "#68D5FF"} />
        </Flex>
        <Text fontSize="1rem" color="white" fontWeight={500}>
          {title}
        </Text>
      </Flex>
      <Divider my={4} />
      <Text fontSize="0.875rem" color="gray.300">
        {description}
      </Text>
    </Box>
  );
};

export default TldrWriterCard;
